__turbopack_context__.v({
  "leftPanel": "Profile-module-scss-module__Av1U0a__leftPanel",
  "mobile": "Profile-module-scss-module__Av1U0a__mobile",
  "navigationSection": "Profile-module-scss-module__Av1U0a__navigationSection",
  "profileAccessibility": "Profile-module-scss-module__Av1U0a__profileAccessibility",
  "profilePageContainer": "Profile-module-scss-module__Av1U0a__profilePageContainer",
  "profilePageSections": "Profile-module-scss-module__Av1U0a__profilePageSections",
  "stickyHeader": "Profile-module-scss-module__Av1U0a__stickyHeader",
  "stickyMiniContactPanel": "Profile-module-scss-module__Av1U0a__stickyMiniContactPanel",
});
